import  { HubConnectionBuilder } from "@microsoft/signalr";
import { NOTIFICATION_URL } from "./constants";
import { signalRHttp } from "./SignalRHttp";


export  const NotificationConnection: any = new HubConnectionBuilder()
.withUrl(NOTIFICATION_URL, {  headers: { "cookie": " " } ,httpClient: new signalRHttp(), accessTokenFactory: () => { return localStorage.getItem("token")??'' }  })
.withAutomaticReconnect()
.build();